<template>
  <button @click="onClick">{{ title }}</button>
</template>

<script>
  export default {
    name: 'RedButton',
    props: ['title', 'onClick'],
  };
</script>

<style scoped>
  button {
    background-color: #bbcee1 !important;
    color: #ffffff !important;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
    box-shadow: inset 0 1px 0 #dde7f0;
    background-image: -webkit-linear-gradient(top, #bbcee1, #9fbcd5);
    border: 1px solid #bbcfe1;
    border-color: #bbcfe1 #a7bed3 #92adc5;
    font-size: 12px;
    padding: 0 10px;
    border-radius: 6px;
    transition-duration: 0.2s;
    user-select: none;
    cursor: pointer;
    text-decoration: none;
    height: 26px;
    line-height: 26px;
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    align-items: flex-start;
    text-align: center;
    box-sizing: border-box;
    -webkit-appearance: push-button;
    white-space: pre;
    -webkit-rtl-ordering: logical;
    text-rendering: auto;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0;
    font: 400 11px system-ui;
    writing-mode: horizontal-tb !important;
  }
  button:hover {
    background-color: #d0deea !important;
    box-shadow: inset 0 1px 0 #e8eff5;
    background-image: -webkit-linear-gradient(top, #d0deea, #9bb9d3);
    background-repeat: repeat-x;
    text-decoration: none;
    color: #ffffff !important;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
    border: 1px solid #bbcfe1;
    border-color: #bbcfe1 #a7bed3 #92adc5;
    font-size: 12px;
    padding: 0px 10px;
    transition-duration: 0.2s;
    user-select: none;
    cursor: pointer;
    font-weight: normal;
    height: 26px;
    line-height: 26px;
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    align-items: flex-start;
    text-align: center;
    box-sizing: border-box;
    -webkit-appearance: push-button;
    white-space: pre;
    -webkit-rtl-ordering: logical;
    text-rendering: auto;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0;
    font: 400 11px system-ui;
    text-rendering: auto;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0px;
    writing-mode: horizontal-tb !important;
  }
  button:active {
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.2);
    background: #9bb6ce !important;
    border: 1px solid #8d9faf;
    border-color: #8d9faf #97b0c6 #9bb6ce;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
    color: #ffffff !important;
    font-size: 12px;
    padding: 0 10px;
    border-radius: 6px;
    transition-duration: 0.2s;
    user-select: none;
    cursor: pointer;
    font-weight: normal;
    text-decoration: none;
    height: 26px;
    line-height: 26px;
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    align-items: flex-start;
    text-align: center;
    box-sizing: border-box;
    -webkit-appearance: push-button;
    white-space: pre;
    -webkit-rtl-ordering: logical;
    text-rendering: auto;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0;
    font: 400 11px system-ui;
    writing-mode: horizontal-tb !important;
  }
</style>
